import "@yaireo/tagify/dist/tagify.css"

import React, {useEffect, useRef} from "react"

import Tagify from "@yaireo/tagify/dist/tagify.min.js"

const clean = (object) => {
  Object.keys(object).forEach(key => object[key] === undefined && delete object[key])
  return object
}

const Tags = ({
  value,
  loading,
  whitelist,
  showFilteredDropdown,
  placeholder,
  delimiters,
  pattern,
  duplicates,
  enforceWhitelist,
  blacklist,
  addTagOnBlur,
  maxTags,
  editTags,
  transformTag,
  keepInvalidTags,
  skipInvalid,
  backspace,
  originalInputValueFormat,
  autoCompleteEnabled,
  autoCompleteRightKey,
  dropdownEnabled,
  dropdownMaxItems,
  dropdownClassname,
  dropdownFuzzySearch,
  dropdownAccentedSearch,
  dropdownPosition,
  dropdownHighlightFirst,
  dropdownCloseOnSelect,
  dropdownMapValueTo,
  dropdownSearchKeys,
  dropdownAppendTarget,
  ...props
}) => {
  const inputElmRef = useRef()
  const tagify = useRef()

  useEffect(() => {
    const autoComplete = clean({
      enabled: autoCompleteEnabled,
      rightKey: autoCompleteRightKey
    })

    const dropdown = clean({
      enabled: dropdownEnabled,
      maxItems: dropdownMaxItems,
      className: dropdownClassname,
      fuzzySearch: dropdownFuzzySearch,
      accentedSearch: dropdownAccentedSearch,
      position: dropdownPosition,
      highlightFirst: dropdownHighlightFirst,
      closeOnSelect: dropdownCloseOnSelect,
      mapValueTo: dropdownMapValueTo,
      searchKeys:dropdownSearchKeys,
      appendTarget: dropdownAppendTarget
    })

    const settings = clean({
      placeholder,
      delimiters,
      pattern,
      duplicates,
      enforceWhitelist,
      blacklist,
      addTagOnBlur,
      maxTags,
      editTags,
      transformTag,
      keepInvalidTags,
      skipInvalid,
      backspace,
      originalInputValueFormat,
      dropdown,
      autoComplete
    })

    tagify.current = new Tagify(inputElmRef.current, settings)

    return () => {
        tagify.current.destroy()
    }
  }, [placeholder, delimiters, pattern, duplicates, enforceWhitelist, blacklist, addTagOnBlur, maxTags,
      editTags, transformTag, keepInvalidTags, skipInvalid, backspace, originalInputValueFormat,
      dropdownEnabled, dropdownMaxItems, dropdownClassname, dropdownFuzzySearch, dropdownAccentedSearch,
      dropdownPosition, dropdownHighlightFirst, dropdownCloseOnSelect, dropdownMapValueTo,
      dropdownSearchKeys, dropdownAppendTarget, autoCompleteEnabled, autoCompleteRightKey])

  useEffect(() => {
    tagify.current.settings.whitelist.splice(
        0,
        tagify.current.settings.whitelist.length,
        ...(whitelist || [])
    )
  }, [whitelist])

  useEffect(() => {
    tagify.current.loadOriginalValues(value)
  }, [value])

  useEffect(() => {
    tagify.current.loading(loading)
  }, [loading])

  useEffect(() => {
    if (showFilteredDropdown) {
      tagify.current.dropdown.show.call(tagify.current, showFilteredDropdown)
      tagify.current.toggleFocusClass(true)
    } else {
      tagify.current.dropdown.hide.call(tagify.current)
    }
  }, [showFilteredDropdown])

  return (
    <div className="-input">
      <input
        ref={inputElmRef}
        type="text"
        value={value && (typeof value === "string" ? value : JSON.stringify(value))}
        {...props}
      />
    </div>
  )
}

export default Tags